import type { TimelineEnvelope } from '../../types';

import { EncounterCard } from './EncounterCard';
import { EnvelopeRow } from './EnvelopeRow';

interface TimelineThreadProps {
  encounter: TimelineEnvelope;
  /** Children are pre-sorted oldest-first by the server (GDN-938 invariant). */
  childEnvelopes: TimelineEnvelope[];
  onOpenEnvelope?: (envelope: TimelineEnvelope) => void;
}

/**
 * Renders an encounter envelope as the thread root, with its children
 * (DocRefs + future kinds) nested inside the card. Threading semantics
 * are server-driven — children always travel with their root in the same
 * page and arrive pre-sorted.
 */
export function TimelineThread({
  encounter,
  childEnvelopes,
  onOpenEnvelope,
}: TimelineThreadProps) {
  return (
    <EncounterCard envelope={encounter}>
      {childEnvelopes.map(child => (
        <EnvelopeRow
          key={child.id}
          envelope={child}
          inThread
          onOpenEnvelope={onOpenEnvelope}
        />
      ))}
    </EncounterCard>
  );
}
